import { render, staticRenderFns } from "./VideoBoostGameStats.vue?vue&type=template&id=6d5d8dd1&"
import script from "./VideoBoostGameStats.vue?vue&type=script&lang=js&"
export * from "./VideoBoostGameStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports